<div class="container-fluid p-3 ">
  <div class="bg-white rounded-md  border-2 border-blue-900 border-gray-300 px-4 py-2 sm:p-6 mb-4">
    <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
    <div class="flex gap-3">
    
      <div class="flex-1">
        <h4 class="text-xl sm:text-2xl font-bold text-slate-800 mb-1">
          {{stepDetails?.name}}
        </h4>
    
        <h5 class="text-base sm:text-lg text-blue-600 font-semibold mb-3">
          [{{ payload?.proposal_name }}]
        </h5>
    
    
      </div>
      <div>
        
        <span class="inline-flex items-center px-3 py-1.5 border-2 rounded-full text-sm font-bold transition-all" [ngClass]="{
                        'bg-slate-100 text-slate-700 border border-slate-500': stepDetails?.step_status == 0,
                        'bg-emerald-100 text-emerald-700 border border-emerald-500': stepDetails?.step_status == 'approved',
                        'bg-amber-100 text-amber-700 border border-amber-500': stepDetails?.step_status == 'recommended',
                        'bg-blue-100 text-blue-700 border border-blue-500': stepDetails?.step_status == 'initiated'
                      }">
          <span class="w-2 h-2 rounded-full mr-2 animate-pulse" [ngClass]="{
                          'bg-slate-500': stepDetails?.step_status == 0,
                          'bg-emerald-500': stepDetails?.step_status == 'approved',
                          'bg-amber-500': stepDetails?.step_status == 'recommended',
                          'bg-blue-500': stepDetails?.step_status == 'initiated'
                        }"></span>
          {{ stepDetails?.step_status == 0 ? " PENDING" : (stepDetails?.step_status | uppercase) }}
        </span>
      </div>
    </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap items-center gap-2">

       

        <ng-container *ngIf="stepDetails?.can_edit">
          <button (click)="routeConfig.emit({isRouteConfig: true})"  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <hr class="my-3" />

  <!-- Vendor Management Section -->
  <app-vendor-management 
  *ngIf="!hideVendorManagement && schemeType == 'rev'"
    [stepDetails]="stepDetails"
    [schemeType]="schemeType || 'rev'"
    [format]="'upload'"
    [url]="'/revenue/dms-file/vendor/'"
    [proposalStepId]="stepDetails?.id || step?.id"
    [proposalId]="stepDetails?.proposal || payload?.proposal_id"
    (vendorAdded)="onVendorAdded($event)"
    (vendorUpdated)="onVendorUpdated($event)"
    (vendorDeleted)="onVendorDeleted($event)"
    (filesSubmitted)="onFilesSubmitted($event)"
  ></app-vendor-management>

  <form [formGroup]="aonSocForm" (ngSubmit)="onSubmit()" class="proposal-form-container">
    <div class="form-container">
       <div class="editor-field mt-4" *ngIf="schemeType =='rev' && stepDetails?.code == 'R-AoN'">
      <!-- <b class="form-label-left">Noting <span class="text-warning">*</span></b> -->
       <b class="form-label-left">Comment</b>
      <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      <!-- <div 
        *ngIf="aonSocForm.controls['comment'].invalid && aonSocForm.controls['comment'].touched" 
        class="text-warning small mt-2">
        Justification is required
      </div> -->
    </div>
       <div class="editor-field mt-4" *ngIf="schemeType =='rev' && stepDetails?.code == 'R-AoN'">
      
       <b class="form-label-left">RFP</b>
      <editor [init]="init" formControlName="rfp" [disabled]="isEditorDisabled"></editor>
      
    </div>

      <!-- Committee Section (schemeType rev only) -->
      <div *ngIf="schemeType == 'rev'" class="mt-4">
        <div class="bg-amber-50 border-2 border-gray-300 mb-6 mt-4 rounded transition-all duration-200 hover:shadow-md" *ngIf="stepDetails?.can_edit">
          <div class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
            <h3 class="text-lg font-semibold flex items-center">
              <span class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-users"></i>
              </span>
              Basic Information
            </h3>
            <i class="pi pi-chevron-down transition-transform duration-200"></i>
          </div>
          <div class="p-6 space-y-4 flex border-t border-slate-100 animate-fade-in">
            <div class="flex flex-col md:flex-row items-center gap-4 w-3/4">
              <label class="block font-medium text-slate-700 mb-2 md:w-1/3">
                Select Committee <span class="text-red-500">*</span>
              </label>
              <div class="w-full md:w-2/3">
                <p-dropdown
                  [options]="schemes"
                  [(ngModel)]="selectedScheme"
                  optionLabel="name"
                  styleClass="w-full md:w-2/3"
                  [filter]="true" filterBy="name" placeholder="Select a Committee"
                  (onChange)="loadSchemeCommittees($event)" appendTo="body"></p-dropdown>
              </div>
            </div>
            <div class="flex justify-end gap-2 mt-4 w-1/4">
              <button type="button" class="btn btn-outline-primary"
                (click)="openAddNewCommitteeDialog()">
                <i class="pi pi-plus me-1"></i>Add New Committee
              </button>
              <button type="button" class="btn btn-warning"
                (click)="addFromExisting()" [disabled]="!selectedScheme">
                <i class="pi pi-plus me-1"></i>Add Committee to Proposal
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="committees?.length">
          <div *ngFor="let committee of committees; let i = index" class="w-full mx-auto my-6 shadow-lg rounded-lg bg-white border border-slate-200 transition-all duration-200 hover:shadow-2xl">
            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-gradient-to-r from-blue-100 to-blue-50 p-5 py-2 border-b-2 border-blue-200 rounded-t-lg">
              <div class="flex items-center gap-2">
                <span class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-blue-200 text-blue-700 text-xl font-bold shadow-sm">
                  <i class="pi pi-users"></i>
                </span>
                <span class="font-bold text-2xl text-slate-800 tracking-tight">{{ committee.name }}</span>
                <span class="inline-block ml-3 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-semibold" *ngIf="committee.members?.length > 0">
                  {{ committee.members.length }} Members
                </span>
              </div>
              <div class="mt-4 sm:mt-0 flex gap-2">
                <button *ngIf="stepDetails?.can_edit"
                  (click)="openDeleteDialog(committee, i)"
                  type="button"
                  class="inline-flex items-center px-3 py-1.5 border border-red-500 text-red-600 rounded-md hover:bg-red-50 hover:border-red-600 transition">
                  <i class="pi pi-trash mr-2"></i> Remove
                </button>
              </div>
            </div>
            <div class="px-3 py-3">
              <div class="rounded-md border border-blue-100 bg-blue-50/50 p-2 mb-4" *ngIf="committee.description">
                <span class="text-sm text-blue-700"><i class="pi pi-info-circle mr-2"></i>{{ committee.description }}</span>
              </div>
              <app-data-table
                [columns]="memberCols"
                [data]="committee.members"
                title="Committee Members"
                [isEditable]="stepDetails?.can_edit"
                [isDeletable]="stepDetails?.can_edit"
                (deleteEventRow)="showDeletePopup($event)"
                [showSearch]="false"
                [showActions]="stepDetails?.can_edit"
                [showAddButton]="stepDetails?.can_edit"
                (onAdd)="openAddCommittee(committee)"
                (editEventRow)="updateCommittemeber($event, committee)">
              </app-data-table>
              <div *ngIf="!committee.members?.length" class="flex flex-col items-center justify-center py-8 opacity-70">
                <i class="pi pi-user-minus text-4xl text-slate-300 mb-2"></i>
                <div class="text-base text-slate-500 font-medium">No members found in this committee.</div>
                <div *ngIf="stepDetails?.can_edit" class="mt-2">
                  <button type="button" class="text-blue-600 border border-blue-400 px-4 py-1.5 rounded hover:bg-blue-100 transition"
                    (click)="openAddCommittee(committee)">
                    <i class="pi pi-plus mr-1"></i> Add Member
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- === Collapsible Section Template Example === -->
      <div class="form-section" *ngIf="schemeType =='rev'">
        <div class="section-header" (click)="toggleSection('basicInfo')">
          <h3 class="section-title">
            Basic Information
            <i class="pi" [ngClass]="expandedSections['basicInfo'] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </h3>
        </div>
        <div class="section-content" *ngIf="expandedSections['basicInfo']">
          <div class="form-grid mb-2">
            <div class="form-field full-width">
              <label for="aon_amount" class="bg-primary text-white">AON Amount<span class="text-warning">*</span></label>
              <input pInputText id="aon_amount" formControlName="aon_amount" autocomplete="off" placeholder="Enter AON Amount" />
            </div>
          </div>
          <div class="form-grid mb-2">
            <div class="form-field full-width">
              <label for="aon_date" class="bg-primary text-white">AON Date<span class="text-warning">*</span></label>
              <input pInputText id="aon_date" type="date" formControlName="aon_date" autocomplete="off"
                [readonly]="schemeType === 'rev'" />
            </div>
            <p class="text-xs text-red-600 italic" *ngIf="schemeType === 'rev'">
          This field will be automatically populated.
        </p>
          </div>
          <div class="form-grid mb-2">
            <div class="form-field full-width">
              <label for="cfa_name" class="bg-primary text-white">CFA<span class="text-warning">*</span></label>
              <input pInputText id="cfa_name" formControlName="cfa_name" autocomplete="off" placeholder="Enter CFA" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-field full-width">
              <label for="file_number" class="bg-primary text-white">File Number<span class="text-warning">*</span></label>
              <input pInputText id="file_number" pSize="large" formControlName="file_number" autocomplete="off" />
            </div>
          </div>
        </div>
      </div>
      <!-- === File Upload Section === -->
      <app-upload-document
        [isEditable]="stepDetails.can_edit"
        [dmsFiles]="documentsForManagement"
        [useParentDmsFiles]="schemeType === 'rev' && (stepDetails?.code === 'R-AoN' || step?.code === 'R-AoN')">
      </app-upload-document>
      
    </div>

    <!-- Justification Editor Section -->
    <div class="editor-field mt-4" *ngIf="schemeType !='rev'">
      <b class="form-label-left">Justification <span class="text-warning">*</span></b>
      <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
      <div 
        *ngIf="aonSocForm.controls['comment'].invalid && aonSocForm.controls['comment'].touched" 
        class="text-warning small mt-2">
        Justification is required
      </div>
    </div>
    <!-- <div class="row mb-4" *ngIf="schemeType =='rev'">
      <div class="col-md-3">
        <label class="form-label">AON Amount</label>
        <input type="text" class="form-control" formControlName="aon_amount" placeholder="Enter AON Amount" />
      </div>
      <div class="col-md-3">
        <label class="form-label">AON Date</label>
        <input type="date" class="form-control" formControlName="aon_date" />
      </div>
      <div class="col-md-3">
        <label class="form-label">CFA Name</label>
        <input type="text" class="form-control" formControlName="cfa_name" placeholder="Enter CFA Name" />
      </div>
      <div class="col-md-3">
        <label class="form-label">File Number</label>
        <input type="text" class="form-control" formControlName="file_number" placeholder="Enter File Number" />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-lg-12">
        <div class="card shadow-sm border-0">
          <div class="card-body p-4">
            <div class="d-flex align-items-center mb-3">
              <i class="pi pi-file text-primary me-2"></i>
              <h5 class="card-title mb-0">Signed Acceptance of Necessity(AoN)</h5>
            </div>
            <p class="text-muted mb-4">Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max
              size: 200MB)</p>
            <div class="upload-container mb-4" 
               *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
            <div class="upload-area p-4 text-center border rounded" >
             
              <p-fileUpload 
                mode="basic" 
                chooseLabel="Browse Files" 
                (uploadHandler)="onFileSelect($event, 'aon')"
                [auto]="true" 
                [customUpload]="true" 
               #aonUploader
                [multiple]="false" 
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" 
                [maxFileSize]="209715200"
                styleClass="p-button-rounded p-button-outlined">
              </p-fileUpload>
            </div>
          </div>

            <div *ngIf="selectedAONFileName || uploadedAonUrl">
              <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                  <div>
                    <p class="mb-0 fw-semibold">
                      <a [href]="apiUrl + uploadedAonUrl" target="_blank" class="text-decoration-none">
                        {{ selectedAONFileName || getFileName(uploadedAonUrl) }}
                      </a>
                    </p>
                    <small class="text-muted">Uploaded successfully</small>
                  </div>
                </div>
                <div class="d-flex gap-2">
                  <a [href]="apiUrl + uploadedAonUrl" target="_blank" class="btn btn-sm btn-outline-primary"
                    *ngIf="uploadedAonUrl">
                    <i class="pi pi-eye"></i>
                  </a>
                  <i class="pi pi-times" (click)="clearUpload()" *ngIf="selectedAONFileName"></i>
                </div>
              </div>
            </div>
            <div *ngIf="!selectedAONFileName && !uploadedAonUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || 
                      (stepDetails?.step_status != 'approved' && userID == 6))"
              class="no-file-placeholder p-3 text-center bg-light rounded">
              <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
              <p class="mb-0 text-muted">No files uploaded</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="row mb-4">
    <div class="col-lg-8">
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <div class="d-flex align-items-center mb-3">
            <i class="pi pi-file text-primary me-2"></i>
            <h5 class="card-title mb-0">Request for Proposal (RFP)</h5>
          </div>
          
          <p class="text-muted mb-4">Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)</p>
          
          <div class="upload-container mb-4" 
               *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
            <div class="upload-area p-4 text-center border rounded" >
              <p-fileUpload 
                mode="basic" 
                chooseLabel="Browse Files" 
                (uploadHandler)="onFileSelect($event, 'rfp')"
                [auto]="true" 
                [customUpload]="true" 
               #socUploader
                [multiple]="false" 
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" 
                [maxFileSize]="209715200"
                styleClass="p-button-rounded p-button-outlined">
              </p-fileUpload>
            </div>
          </div>
         
          <div *ngIf="selectedSOCFileName || uploadedSocUrl">
            <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                <div>
                  <p class="mb-0 fw-semibold">
                    <a [href]="apiUrl + uploadedAonUrl" target="_blank" class="text-decoration-none">
                      {{ selectedSOCFileName || getFileName(uploadedSocUrl) }}
                    </a>
                  </p>
                  <small class="text-muted">Uploaded successfully</small>
                </div>
              </div>
              <div class="d-flex gap-2">
                <a [href]="apiUrl + uploadedSocUrl" target="_blank" class="btn btn-sm btn-outline-primary"  *ngIf="uploadedSocUrl">
                  <i class="pi pi-eye"></i>
                </a>
                
                  <i class="pi pi-times"  (click)="clearUpload()" *ngIf="selectedSOCFileName"></i>
                
              </div>
            </div>
          </div>

          <div *ngIf="!selectedSOCFileName && !uploadedSocUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || 
                      (stepDetails?.step_status != 'approved' && userID == 6))" 
               class="no-file-placeholder p-3 text-center bg-light rounded">
            <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
            <p class="mb-0 text-muted">No files uploaded</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Committee dialogs (schemeType rev only) -->
  <ng-container *ngIf="schemeType == 'rev'">
    <!-- Add Committee Dialog (new committee) -->
    <p-dialog header="Add Committee" [(visible)]="addNewCommitteeDialog" [modal]="true" [style]="{ width: '420px' }"
      [closable]="true" [dismissableMask]="true" [maximizable]="true">
      <form [formGroup]="committeeForm" (ngSubmit)="onCommitteeSubmit()">
        <label class="form-label fw-semibold">Committee Name <span class="text-danger">*</span></label>
        <input type="text" class="form-control mb-1" formControlName="committeeName" placeholder="Enter committee name" />
        <div class="text-danger small" *ngIf="committeeForm.get('committeeName')?.touched && committeeForm.get('committeeName')?.invalid">
          Name is required.
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary" [disabled]="committeeForm.invalid">
            <i class="pi pi-plus me-1"></i> Add
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Update Committee Dialog -->
    <p-dialog header="Update Committee" [(visible)]="updateCommitteDialog" [modal]="true" [style]="{ width: '420px' }"
      [closable]="true" [dismissableMask]="true" [maximizable]="true">
      <form [formGroup]="committeeForm" (ngSubmit)="updateSubmit()">
        <label class="form-label fw-semibold">Committee Name</label>
        <input type="text" class="form-control mb-1" formControlName="committeeName" placeholder="Enter committee name" />
        <div class="text-danger small" *ngIf="committeeForm.get('committeeName')?.touched && committeeForm.get('committeeName')?.invalid">
          Name is required.
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary" [disabled]="committeeForm.invalid || committeeForm.pristine">
            Submit
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Delete Committee Dialog -->
    <p-dialog header="Delete Committee" [(visible)]="showDeleteConfirmDialog" [modal]="true" [closable]="true"
      [style]="{ width: '400px' }" [maximizable]="true">
      <div class="p-3">
        <p>Are you sure you want to remove the committee <strong>{{ committeeToDelete?.name }}</strong> from the proposal?</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn btn-sm btn-secondary me-2" (click)="showDeleteConfirmDialog = false">Cancel</button>
        <button class="btn btn-sm btn-danger" (click)="confirmDeleteCommittee()">
          <i class="pi pi-trash me-1"></i> Delete
        </button>
      </ng-template>
    </p-dialog>

    <!-- Update Committee Member -->
    <p-dialog header="Update Member" [(visible)]="editMemberDialog" [modal]="true" [style]="{ width: '50vw' }" [closable]="true"
      [dismissableMask]="true" appendTo="body" [maximizable]="true">
      <form [formGroup]="assignmentForm" (ngSubmit)="onAssignmentUpdateSubmit()">
        <div class="row g-2 p-4">
          <div class="col-12">
            <label class="bg-primary text-white rounded p-2 w-25 d-inline-block mb-2">User <span class="text-danger">*</span></label>
            <div class="w-100">
              <div class="d-flex gap-3 mb-3">
                <label class="d-flex align-items-center cursor-pointer">
                  <input type="radio" name="userInputModeEdit" [value]="'dropdown'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="me-2" [ngModelOptions]="{standalone: true}" />
                  <span class="small">Select from List</span>
                </label>
                <label class="d-flex align-items-center cursor-pointer">
                  <input type="radio" name="userInputModeEdit" [value]="'manual'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="me-2" [ngModelOptions]="{standalone: true}" />
                  <span class="small">Manual Entry</span>
                </label>
              </div>
              <div *ngIf="userInputMode === 'dropdown'">
                <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user"
                  placeholder="Search/select user" [filter]="true" [showClear]="true" [autoDisplayFirst]="false"
                  filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" appendTo="body" styleClass="w-full">
                  <ng-template pTemplate="selectedItem" let-user>
                    <div *ngIf="user; else noSel1"><small>
                      Directorate <strong>{{ user.unit.name }}</strong> | #<strong>{{ user.loginname }}</strong> |
                      <strong>{{ user.first_name }} {{ user.last_name }}</strong>
                    </small></div>
                    <ng-template #noSel1><span class="text-muted">Choose a user</span></ng-template>
                  </ng-template>
                  <ng-template pTemplate="item" let-user>
                    <div><small>
                      Directorate <strong>{{ user.unit.name }}</strong> | #<strong>{{ user.loginname }}</strong> |
                      <strong>{{ user.first_name }} {{ user.last_name }}</strong> | <strong>{{ user.hrcdf_designation }}</strong>
                    </small></div>
                  </ng-template>
                </p-dropdown>
                <div *ngIf="assignmentForm.get('user')?.touched && assignmentForm.get('user')?.invalid" class="text-danger small mt-1">
                  Please select a user.
                </div>
              </div>
              <div *ngIf="userInputMode === 'manual'">
                <input type="text" class="form-control" formControlName="user_name"
                  placeholder="Enter Designation/Name (e.g. Director, John Doe)" maxlength="200" autocomplete="off" />
                <div *ngIf="assignmentForm.get('user_name')?.touched && assignmentForm.get('user_name')?.invalid" class="text-danger small mt-1">
                  Please enter user name/designation.
                </div>
                <div class="text-muted small mt-1">
                  <i class="pi pi-info-circle me-1"></i>Enter the user's designation or name manually
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 d-flex align-items-center">
            <label class="bg-primary text-white rounded p-2 w-25">Role <span class="text-danger">*</span></label>
            <div class="w-75 ms-2">
              <input type="text" class="form-control" formControlName="role" placeholder="e.g. Chairperson, Member Secretary"
                maxlength="80" autocomplete="off" />
              <div *ngIf="assignmentForm.get('role')?.touched && assignmentForm.get('role')?.invalid" class="text-danger small mt-1">
                Role is required.
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="submit" class="btn btn-primary px-4" [disabled]="assignmentForm.invalid">
            <i class="pi pi-check me-2"></i>Update
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Add Committee Member -->
    <p-dialog header="Add Member" [(visible)]="addCommitteeDialog" [modal]="true" [style]="{ width: '50vw' }" [closable]="true"
      [dismissableMask]="true" appendTo="body" [maximizable]="true">
      <form [formGroup]="assignmentForm" (ngSubmit)="onAssignmentSubmit()">
        <div class="space-y-4 m-3">
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              User <span class="text-red-500">*</span>
            </label>
            <div class="w-full md:w-3/4">
              <div class="flex gap-4 mb-3">
                <label class="flex items-center cursor-pointer">
                  <input type="radio" name="userInputMode" [value]="'dropdown'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="mr-2" [ngModelOptions]="{standalone: true}" />
                  <span class="text-sm font-medium">Select from List</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input type="radio" name="userInputMode" [value]="'manual'" [(ngModel)]="userInputMode"
                    (change)="onUserInputModeChange()" class="mr-2" [ngModelOptions]="{standalone: true}" />
                  <span class="text-sm font-medium">Manual Entry</span>
                </label>
              </div>
              <div *ngIf="userInputMode === 'dropdown'">
                <p-dropdown [options]="userList" optionLabel="first_name" formControlName="user"
                  placeholder="Search/select user" [filter]="true" [showClear]="true" [autoDisplayFirst]="false"
                  filterBy="first_name,last_name,hrcdf_designation,loginname,unit.name" appendTo="body" styleClass="w-full">
                  <ng-template pTemplate="selectedItem" let-user>
                    <div *ngIf="user; else noSel2" class="text-sm text-gray-700">
                      <span>Directorate <span class="font-semibold">{{ user.unit.name }}</span> | #<span class="font-semibold">{{ user.loginname }}</span> |
                        <span class="font-semibold">{{ user.first_name }} {{ user.last_name }}</span></span>
                    </div>
                    <ng-template #noSel2><span class="text-gray-400">Choose a user</span></ng-template>
                  </ng-template>
                  <ng-template pTemplate="item" let-user>
                    <div class="text-sm">Directorate <span class="font-semibold">{{ user.unit.name }}</span> | #<span class="font-semibold">{{ user.loginname }}</span> |
                      <span class="font-semibold">{{ user.first_name }} {{ user.last_name }}</span> | <span class="font-semibold">{{ user.hrcdf_designation }}</span></div>
                  </ng-template>
                </p-dropdown>
                <div *ngIf="assignmentForm.get('user')?.touched && assignmentForm.get('user')?.invalid" class="text-xs text-red-500 mt-1">
                  Please select a user.
                </div>
              </div>
              <div *ngIf="userInputMode === 'manual'">
                <input type="text" class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                  formControlName="user_name" placeholder="Enter Designation/Name (e.g. Director, John Doe)"
                  maxlength="200" autocomplete="off" />
                <div *ngIf="assignmentForm.get('user_name')?.touched && assignmentForm.get('user_name')?.invalid" class="text-xs text-red-500 mt-1">
                  Please enter user name/designation.
                </div>
                <div class="text-xs text-gray-500 mt-1">
                  <i class="pi pi-info-circle mr-1"></i>Enter the user's designation or name manually
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-3">
            <label class="block w-full md:w-1/4 bg-blue-600 text-white rounded-md px-3 py-2 font-medium">
              Role <span class="text-red-500">*</span>
            </label>
            <div class="w-full md:w-3/4">
              <input type="text" class="form-input w-full border border-gray-300 rounded-md py-2 px-3 focus:border-blue-500 focus:outline-none"
                formControlName="role" placeholder="e.g. Chairperson, Member Secretary" maxlength="80" autocomplete="off" />
              <div *ngIf="assignmentForm.get('role')?.touched && assignmentForm.get('role')?.invalid" class="text-xs text-red-500 mt-1">
                Role is required.
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-6">
          <button type="submit" class="inline-flex items-center bg-blue-600 text-white px-5 py-2 rounded-md font-semibold shadow hover:bg-blue-700 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            [disabled]="assignmentForm.invalid">
            <i class="pi pi-plus mr-2"></i>Add
          </button>
        </div>
      </form>
    </p-dialog>

    <!-- Delete Committee Member -->
    <p-dialog header="Delete Member" [(visible)]="deleteMember" [modal]="true" [closable]="true"
      [style]="{ width: '330px' }" appendTo="body" [maximizable]="true">
      <div class="p-3">
        <p>Are you sure you want to remove the committee member from the proposal?</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="btn btn-sm btn-danger" (click)="ConfirmMemberDelete()">
          <i class="pi pi-trash me-1"></i> Delete
        </button>
      </ng-template>
    </p-dialog>
  </ng-container>
  </form>
</div>